import "core-js/modules/es.array.map.js";
import { full } from "../../design";
import { useResponsive } from "../../utils";
import { useHasElementScrolledOutOfView } from "../../utils/useHasElementScrolledOutOfView";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
 * Renders a bar that sticks to the top of the viewport or container when
 * scrolling.  Shows a drop shadow when the bar is scrolled out of view.
 */
export function StickyBar(_ref) {
  var children = _ref.children,
    _ref$top = _ref.top,
    top = _ref$top === void 0 ? 0 : _ref$top,
    _ref$px = _ref.px,
    px = _ref$px === void 0 ? 0 : _ref$px,
    _ref$py = _ref.py,
    py = _ref$py === void 0 ? 0 : _ref$py,
    pt = _ref.pt,
    pb = _ref.pb,
    _ref$sticky = _ref.sticky,
    sticky = _ref$sticky === void 0 ? true : _ref$sticky,
    containerRef = _ref.containerRef,
    borderTopRadius = _ref.borderTopRadius,
    _ref$wings = _ref.wings,
    wings = _ref$wings === void 0 ? 0 : _ref$wings;
  var _useHasElementScrolle = useHasElementScrolledOutOfView({
      containerRef: containerRef,
      topMargin: top
    }),
    elementRef = _useHasElementScrolle.elementRef,
    hasScrolledOutOfView = _useHasElementScrolle.hasScrolledOutOfView;
  var responsive = useResponsive();
  return _jsxs(_Fragment, {
    children: [_jsx("div", {
      ref: elementRef
    }), _jsxs("div", {
      css: function css(theme) {
        return responsive.css({
          position: responsive.map(sticky, function (val) {
            return val ? 'sticky' : 'static';
          }),
          top: top,
          backgroundColor: 'white',
          zIndex: 1,
          borderTopLeftRadius: borderTopRadius ? full(theme).borderRadiuses[borderTopRadius] : undefined,
          borderTopRightRadius: borderTopRadius ? full(theme).borderRadiuses[borderTopRadius] : undefined
        });
      },
      "data-testid": "crystal-ui-sticky-bar",
      children: [!!wings && _jsxs(_Fragment, {
        children: [_jsx("div", {
          css: function css(theme) {
            return responsive.css({
              backgroundColor: 'white',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: "-".concat(theme.spacing[wings]),
              width: theme.spacing[wings],
              display: responsive.map(sticky, function (val) {
                return val ? 'block' : 'none';
              })
            });
          }
        }), _jsx("div", {
          css: function css(theme) {
            return responsive.css({
              backgroundColor: 'white',
              height: '100%',
              position: 'absolute',
              top: 0,
              right: "-".concat(theme.spacing[wings]),
              width: theme.spacing[wings],
              display: responsive.map(sticky, function (val) {
                return val ? 'block' : 'none';
              })
            });
          }
        })]
      }), _jsx("div", {
        css: function css(theme) {
          return {
            paddingTop: typeof pt !== 'undefined' ? theme.spacing[pt] : theme.spacing[py],
            paddingBottom: typeof pb !== 'undefined' ? theme.spacing[pb] : theme.spacing[py],
            paddingLeft: theme.spacing[px],
            paddingRight: theme.spacing[px],
            position: 'relative' // Ensure wings don't overlap on-top of the children
          };
        },
        children: children
      }), _jsx("div", {
        css: responsive.css({
          // This fake element fills the parent element and is only used to
          // display the drop-shadow.  We use a fake element so the clipPath
          // does not cut off elements that overflow the parent element.
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          // Cut-off the shadow on the top, right, and left of the bar.
          // See: https://stackoverflow.com/a/42848161
          // overflowX: 'hidden' does not work here because it also cuts off
          // bottom drop-shadow
          clipPath: 'inset(1px 1px -5px 1px)',
          boxShadow: hasScrolledOutOfView ? '0px 2px 4px 0px rgba(0, 0, 0, 0.20)' : undefined,
          transition: 'box-shadow 100ms',
          display: sticky ? responsive.map(sticky, function (val) {
            return val ? 'block' : 'none';
          }) : 'none'
        }),
        "data-testid": "crystal-ui-sticky-bar-drop-shadow"
      })]
    })]
  });
}